import $ from 'jquery';
import DataService from './DataService';
import ContentList from './ContentList';

(async () => {
	const dataService = new DataService();
	const data = await dataService.list('contents');

	data.forEach((item, i) => {
		if (item.sortierung === '') {
			item.sortierung = 0;
		}
	});
	data.sort((a, b) => (a.sortierung > b.sortierung ? 1 : b.sortierung > a.sortierung ? -1 : 0));

	new ContentList('#contentList', data).bindData();

	$('[data-bind]').each((index, element) => {
		const key = $(element).data('bind');
		$(element).html(data[key]);
	});
})();
